import React from "react";
import EnlaceAModal, { ContenidoDeEnlace } from "./EnlaceAModal";
import { Link } from "react-router-dom";
import Default from "./Default";
import { getAtributo } from "../../../context/FuncionesContext";

const EnlaceOpcional = ({
  data,
  cab,
  id,
  campokey,
  hijos,
  id_elemento,
  qsBody,
}) => {
  const e = getAtributo("enlace", data, cab);
  const id_a_attr = getAtributo("enlace_id_a", data, cab);
  const enlace_id_a =
    data[cab.id_a + "_enlace_id_a"] ?? cab.enlace_id_a ?? id_a_attr ?? "";

  const iconClassName = getAtributo("icon_className", data, cab);

  // console.log("[EnlaceOpcional] props", { id, campokey, id_elemento, qsBody });
  // console.log("[EnlaceOpcional] cab IN", cab);
  // console.log("[EnlaceOpcional] data sample keys", Object.keys(data || {}));

  if (!enlace_id_a && cab.enlace_externo !== "s") {
    // console.log(
    //   "[EnlaceOpcional] sin enlace_id_a y NO es externo -> render <Default/>"
    // );
    return (
      <Default
        key={cab.id_a}
        data={data}
        cab={cab}
        hijos={hijos}
        campokey={campokey}
      />
    );
  }

  const nombre = getAtributo("nombre");
  const boton_texto = getAtributo("boton_texto");

  let paramObj = {};

  const parametros = (() => {
    let parametros_keys = [];
    let parametros_valores = [];

    if (cab.enlace_parametros_nombres_alias) {
      parametros_keys = cab.enlace_parametros_nombres_alias
        .split(",")
        .map((alias) => data[alias])
        .filter((e) => e);
    } else {
      parametros_keys =
        cab.enlace_parametros_nombres?.split(",").filter((e) => e) || [];
    }

    if (cab.enlace_parametros_alias) {
      parametros_valores = cab.enlace_parametros_alias
        .split(",")
        .map((alias) => data[alias])
        .filter((e) => e);
    } else {
      parametros_valores =
        cab.enlace_parametros?.split(",").filter((e) => e) || [];
    }

    let qs = "?";
    const keys = parametros_keys || [];
    keys.forEach((key, i) => {
      if (parametros_valores[i] !== undefined && parametros_valores[i] !== null) {
        qs = qs.concat(`&${key}=${parametros_valores[i]}`);
        paramObj[key] = parametros_valores[i];
      }
    });

    if (qs === "?") qs = "";

    // console.log("[EnlaceOpcional] parametros", {
    //   parametros_keys,
    //   parametros_valores,
    //   paramObj,
    //   qs,
    // });
    return qs;
  })();

  const esExterno = cab.enlace_externo === "s";

  const hrefExterno = `${e ?? ""}${parametros ?? ""}`;
  const hrefInternoHash =
    (process.env.PUBLIC_URL || "") +
    "/#" +
    (e ?? "") +
    (enlace_id_a ?? "") +
    (parametros ?? "");

  // console.log("[EnlaceOpcional] resueltos", {
  //   e,
  //   enlace_id_a,
  //   esExterno,
  //   hrefExterno,
  //   hrefInternoHash,
  //   target: cab.target,
  // });

  if (cab.target === "modal") {
    // console.log("[EnlaceOpcional] Rama: MODAL");
    return (
      <EnlaceAModal
        nombre={nombre}
        paramObj={paramObj}
        cab={cab}
        data={data}
        id_elemento={id_elemento}
        qsBody={qsBody}
        enlace_id_a={enlace_id_a}
        campokey={campokey}
      />
    );
  }

  if (cab.target === "_blank") {
    const href = esExterno ? hrefExterno : hrefInternoHash;
    // console.log("[EnlaceOpcional] Rama: _blank", { href });

    return (
      <div
        id={id_elemento}
        className={cab.className}
        style={{ display: "flex" }}
        title={data[cab.id_a + "_tooltip_texto"] ?? cab.tooltip_texto}
      >
        {nombre ? (
          <div className="vista_label" style={{ fontWeight: "bold" }}>
            {nombre}:{" "}
          </div>
        ) : null}
        <a className="enlace" target="_blank" href={href} rel="noopener noreferrer">
          <div style={{ textAlign: "center" }}>
            <ContenidoDeEnlace
              texto={
                data[campokey] ?? boton_texto
              }
              imagen={cab.imagen_url}
              iconClassName={iconClassName}
            />
            {hijos}
          </div>
        </a>
      </div>
    );
  }

  // Caso general
  if (esExterno) {
    // console.log("[EnlaceOpcional] Rama: EXTERNO normal", { hrefExterno });
    return (
      <div id={id_elemento} style={{ display: "flex" }} title={cab.tooltip_texto}>
        {nombre ? (
          <div className={`vista_label`} style={{ fontWeight: "bold" }}>
            {nombre}:{" "}
          </div>
        ) : null}
        <div className={`vista_dato ${cab.className}`}>
          <a className="enlace" href={hrefExterno} rel="noopener noreferrer">
            <ContenidoDeEnlace
              texto={
                data[campokey] ?? boton_texto
              }
              imagen={cab.imagen_url}
              iconClassName={iconClassName}
            />
          </a>
        </div>
      </div>
    );
  }

  // Interno (SPA)
  const toObj = {
    pathname: (e ?? "") + (enlace_id_a ?? ""),
    search: parametros,
  };
  // console.log("[EnlaceOpcional] Rama: INTERNO <Link>", { toObj });

  return (
    <div id={id_elemento} style={{ display: "flex" }} title={cab.tooltip_texto}>
      {nombre ? (
        <div className={`vista_label`} style={{ fontWeight: "bold" }}>
          {nombre}:{" "}
        </div>
      ) : null}
      <div className={`vista_dato  ${cab.className}`}>
        <Link to={toObj}>
          <ContenidoDeEnlace
            texto={
              data[campokey] ?? boton_texto
            }
            imagen={cab.imagen_url}
            iconClassName={iconClassName}
          />
        </Link>
      </div>
    </div>
  );
};
export default EnlaceOpcional;
